import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SETTINGS = {
  phone: "+351 000 000 000",
  whatsapp: "351000000000",
  email: "geral@solutioncarpremium.pt",
  address: "Morada do stand — a definir",
  facebook: "https://facebook.com/",
  instagram: "https://instagram.com/",
  linkedin: "https://linkedin.com/",
};

export function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((res) => {
        const d = res.data || {};
        setSettings((s) => ({
          phone: d.phone || s.phone,
          whatsapp: d.whatsapp || s.whatsapp,
          email: d.email || s.email,
          address: d.address || s.address,
          facebook: d.facebook || s.facebook,
          instagram: d.instagram || s.instagram,
          linkedin: d.linkedin || s.linkedin,
        }));
      })
      .catch(() => {});
  }, []);

  return settings;
}
